exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.trans-label{color:red}.trans-holder .m-form__group:last-child{padding-bottom:15px}.trans-holder .m-form__group:first-child{padding-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f0f7ccf","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/metronic/form/TextareaTrans.vue
// module id = pibc
// module chunks = 0 1 2